import { config } from 'ENV_CONFIG';

import { appointmentActions, loadClientDetails } from '~/api';
import { questionsActions } from '~/components';
import { loadPartners } from '../partners/partners.actions';
import { isNotEmpty } from '~/utils';

const getInitialAnalyticsQuestionSection = () => {
  const section = {};
  const addQuestionReduxNameToSection = (question) => {
    section[question.reduxFieldConfig.name] = '';
  };
  Object.values(config.howDidYouHearAboutOurServiceAnalyticsQuestions).forEach((parent) => {
    addQuestionReduxNameToSection(parent);
    parent.children.forEach(addQuestionReduxNameToSection);
  });
  return section;
};

export const restoreAppointmentData =
  (termsConditions, analyticsQuestionSection) => (dispatch, getState) => {
    const {
      appointment: {
        draft: {
          appointmentType: { id: appointmentTypeId },
          shop: { id: shopId },
        },
      },
      partners: { partners },
      services: {
        config: { questionsSectionsConfig, isServiceWithoutPartners },
      },
    } = getState();

    const isLoadedPartners = partners.length > 0;
    return Promise.all([
      dispatch(appointmentActions.loadAppointment(shopId)),
      dispatch(loadClientDetails()),
      dispatch(questionsActions.retrieveQuestions(appointmentTypeId)),
      !isServiceWithoutPartners && !isLoadedPartners && dispatch(loadPartners()),
    ]).then(() => {
      const {
        appointment: { appointment },
        client: { details: clientDetails },
        questions: { questions },
      } = getState();

      const allQuestions = Object.values(questions).reduce((output, categoryQuestions) => {
        const concatenatedQuestions = output.concat(categoryQuestions);
        return concatenatedQuestions.reduce(
          (acc, curr) =>
            curr.children && curr.children.length
              ? [...acc, curr, ...curr.children]
              : [...acc, curr],
          [],
        );
      }, []);

      const answers = {};

      allQuestions
        .filter((question) => !!question.defaultValue && question.defaultValue.length > 0)
        .forEach((question) => {
          answers[question.reduxFieldConfig.name] = question.restoreAnswer({
            question,
            answers: question.defaultValue,
          });
        });

      appointment.answers.forEach((answer) => {
        const question = allQuestions.find((el) => el.id === answer.questionId);

        if (question) {
          answers[question.reduxFieldConfig.name] = question.restoreAnswer({
            question,
            answers: answer.answers,
          });
        }
      });

      const displayQuestionsInYourDetailsSection =
        questionsSectionsConfig &&
        questionsSectionsConfig[0] &&
        questionsSectionsConfig[0].displayQuestionsInYourDetails;

      dispatch(
        questionsActions.setRestoredAnswers({
          yourDetailsSection: {
            ...clientDetails,
            ...(displayQuestionsInYourDetailsSection ? answers : {}),
          },
          questionsSection: {
            ...(displayQuestionsInYourDetailsSection ? {} : answers),
          },
          termsConditions: {
            termsConditions: termsConditions ? 'true' : '',
          },
          analyticsQuestionSection: {
            ...(isNotEmpty(analyticsQuestionSection)
              ? analyticsQuestionSection
              : getInitialAnalyticsQuestionSection()),
          },
        }),
      );
    });
  };
